"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelStatus = void 0;
var ModelStatus;
(function (ModelStatus) {
    ModelStatus["Pending"] = "pending";
    ModelStatus["Success"] = "success";
})(ModelStatus || (exports.ModelStatus = ModelStatus = {}));
